import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=07b877c4"
import script from "./Delete.ts?vue&type=script&lang=ts&external"
export * from "./Delete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports